import { render, staticRenderFns } from "./w-number-grow.vue?vue&type=template&id=460a45a3&scoped=true&"
import script from "./w-number-grow.vue?vue&type=script&lang=js&"
export * from "./w-number-grow.vue?vue&type=script&lang=js&"
import style0 from "./w-number-grow.vue?vue&type=style&index=0&id=460a45a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460a45a3",
  null
  
)

export default component.exports